import React from 'react';
import PropTypes from 'prop-types';
import closeIcon from '../../../../../images/front/hospitals_search/icon/close';
import closeIcon02 from '../../../../../images/front/hospitals_search/icon/close02';
import FetchPublicApiComponent from '../../../../common/atoms/FetchPublicApiComponent';
import { JapaneseSyllabaryLines } from '../../atoms/hospitals/index';
import ModalItem from './ModalItem';
import styles from './Modal.module.scss';

class ModalDiseases extends FetchPublicApiComponent {
  constructor (props) {
    super(props);
    this.state = {
      word: '',
      allDiseases: {},
      loading: true,
      isActiveResult0: false,
      isActiveKa: true,
      isActiveDiseasesOther: true
    };
    this.inputWord = this.inputWord.bind(this);
    this.fetchAllDiseases = this.fetchAllDiseases.bind(this);
    this.extractSuggestDepartment = this.extractSuggestDepartment.bind(this);
  }

  componentDidMount () {
    this.fetchAllDiseases();
  }

  fetchAllDiseases () {
    const apiLocation = '/public/api/diseases';
    this
      .fetch(apiLocation)
      .then(data => {
        this.setState(
          {
            allDiseases: data.diseases,
            loading: false
          }
        );
      });
  }

  inputWord (event) {
    const word = event.target.value;
    this.setState({ word: word });
  }

  // 診療科目を絞り込む
  extractSuggestDepartment (word) {
    if (word === undefined || word.length === 0) {
      return this.props.departmentSection;
    }

    const departmentData = {};
    Object.entries(this.props.departmentSection).forEach((department) => {
      const [name, items] = department;
      const filteredItems = Object.entries(items).filter(item => item[1].includes(word));
      if (filteredItems.length > 0) {
        departmentData[name] = Object.fromEntries(filteredItems);
      }
    });

    return departmentData;
  }

  extractSuggestCampaignCode (word) {
    if (!word) {
      return this.props.campaignCodesToDisplay;
    }

    return this.props.campaignCodesToDisplay.filter(({ kana, name }) =>
      kana.includes(word) || name.includes(word)
    );
  }

  canDisplaySuggestDiseases () {
    return this.state.loading;
  }

  extractSuggestDiseases (word) {
    const suggestDiseases = this.state.allDiseases.filter((disease) => {
      return disease.kana.includes(word) || disease.name.includes(word);
    });
    return suggestDiseases;
  }

  groupDiseasesByLine (diseases) {
    const groupedDiseasesByLine = JapaneseSyllabaryLines.all().map(line => {
      const matchedDiseases = diseases.filter((disease) => {
        return line.regex.test(disease.kana.substr(0, 1));
      });
      return {
        lineName: line.lineName,
        diseases: matchedDiseases
      };
    }).filter(group => group.diseases.length > 0);
    return groupedDiseasesByLine;
  }

  renderSuggestDiseases () {
    const diseases = this.state.word === '' ? this.state.allDiseases : this.extractSuggestDiseases(this.state.word);
    if (diseases.length === 0) { return this.renderSuggestResult0(); }

    return (
      <>
        {this.groupDiseasesByLine(diseases).map(groupedDiseases => {
          return (
            <React.Fragment key={groupedDiseases.lineName}>
              <p className="p-hospitals-search__modal-contents-subtitle js-search-ka" style={{ display: 'block' }}>{groupedDiseases.lineName}</p>
              <ul className={`p-hospitals-search__modal-contents-list js-search-ka ${styles.modalListFlexbox}`}>
                { groupedDiseases.diseases.map(disease => {
                  return (
                    <li key={`${disease.name}${disease.code}`} className="p-hospitals-search__modal-contents-list-item  js-search-ka" style={{ display: 'block' }}>
                      <a
                        className="p-hospitals-search__modal-contents-list-link js-diseases-input"
                        onClick={() => this.props.handleSelectDisease(disease)}
                      >
                        {disease.name}
                        <span>
                          {disease.kana}
                        </span>
                      </a>
                    </li>
                  );
                })}
              </ul>
            </React.Fragment>
          );
        })}
      </>
    );
  }

  renderSuggestResult0 () {
    return (
      <p className="p-hospitals-search__modal-contents-result0" style={{ display: 'block' }}>
        検索結果はありません
      </p>
    );
  }

  renderSearching () {
    return (
      <p className="p-hospitals-search__modal-contents-searching" style={{ display: 'block' }}>
        検索中です...
      </p>
    );
  }

  render () {
    const {
      isActive,
      closeModal
    } = this.props;

    const style = {
      display: isActive ? 'block' : 'none'
    };

    const departmentData = this.extractSuggestDepartment(this.state.word);
    const campaignCodeData = this.extractSuggestCampaignCode(this.state.word);

    return (
      <div className="p-hospitals-search__modal-diseases" style={style}>
        <div className="p-hospitals-search__modal-diseases-header">
          <img src={this.props.config.assetHost + closeIcon} width="24" className="p-hospitals-search__modal-area-header-icon-close js-modal-area-close" onClick={closeModal} alt="" />
          <img src={this.props.config.assetHost + closeIcon02} width="32" className="p-hospitals-search__modal-area-header-icon-close-pc js-modal-area-close" onClick={closeModal} alt="" />
          <div className="p-hospitals-search__modal-diseases-header-title-wrap">
            <span className="p-hospitals-search__modal-diseases-header-title">病名 / 診療科目を選択</span>
          </div>
          <div className="p-hospitals-search__modal-diseases-header-input-wrap">
            <input className="c-input-text-responsive js-input-diseases" value={this.state.word} name="" id="" type="text" placeholder="病名・診療科名で絞り込む" onChange={this.inputWord} />
          </div>
        </div>
        <div className="p-hospitals-search__modal-contents-diseases">
          {/* 専門的な医療機関(キャンペーンコード) */}
          <div className="p-hospitals-search__modal-speciality-contents">
            <p className="p-hospitals-search__modal-contents-title">専門的な医療機関をお探しの方へ</p>
            <ul className="p-hospitals-search__modal-contents-list">
              {campaignCodeData.map(({ code, name, kana }) => {
                return <li key={code} className="p-hospitals-search__modal-contents-list-item">
                  <a className="p-hospitals-search__modal-contents-list-link js-speciality-input" onClick={() => this.props.handleSelectCampaignCode({ code, name })} >
                    {name}
                    <span>
                      {kana}
                    </span>
                  </a>
                </li>;
              }
              )}
            </ul>
            { !campaignCodeData.length && this.renderSuggestResult0() }
          </div>
          {/* 病名 */}
          <div className="p-hospitals-search__modal-diseases-contents">
            <p className="p-hospitals-search__modal-contents-title">病名</p>
            { this.canDisplaySuggestDiseases() ? this.renderSearching() : this.renderSuggestDiseases()}
          </div>
          {/* 診療科目 */}
          <div className="p-hospitals-search__modal-diseases-contents">
            <p className="p-hospitals-search__modal-contents-title--subject">診療科目</p>
            {Object.entries(departmentData).map((department, idx) => {
              const [name, items] = department;
              return (
                <ModalItem key={idx} subTitle={name} itemList={Object.entries(items)} isActiveKa={this.state.isActiveKa} handleSelectDepartment={this.props.handleSelectDepartment} />
              );
            })}
            {Object.keys(departmentData).length === 0 &&
              this.renderSuggestResult0()
            }
          </div>
        </div>
      </div>
    );
  }
}

ModalDiseases.propTypes = {
  departmentSection: PropTypes.object.isRequired
};

export default ModalDiseases;
